import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import Table from "../../../../../../common/components/table";
import { useAppDispatch } from "../../../../../../hooks/hooks";
import { selectDbnpListItems } from "../../../../../../redux/dbnp/selector";
import { dbnp } from "../../../../../../redux/dbnp/action";
import { useNavigate } from "react-router-dom";
import PageLoader from "../../../../../../components/PageLoader";

const ManagementDbnps = () => {
	const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [pageData, setPageData] = useState(1)
    const dbnpItems = useSelector(selectDbnpListItems)
    const [
        columnDefs,
        setColumnDefs
      ] = useState({});
      const createColumnDefs: any = () => {
        setColumnDefs([
          {
            field: 'Sl',
            sortable: false,
            filter: false,
            isSortLabel: true,
            headerName: 'Sl',
            cellRenderer (params: any) {
              return parseInt(
                params.node.id,
                10
              ) + 1;
            },
          },
          { field: 'Name', headerName: 'Name' },
      { field: 'IsJoinAsDBNConsumer', headerName: 'JoinAsDBNConsumer', cellRenderer: 'yesNoRenderer' },
      { field: 'IsJoinAsDBNProvider', headerName: 'JoinAsDBNProvider', cellRenderer: 'yesNoRenderer' },
      { field: 'IsJoinAsDBNVendor', headerName: 'JoinAsDBNVendor', cellRenderer: 'yesNoRenderer' },
      { field: 'IsJoinAsDBNSupplier', headerName: 'JoinAsDBNSupplier', cellRenderer: 'yesNoRenderer' },
      { field: 'IsJoingAsDBNPartner', headerName: 'JoingAsDBNPartner', cellRenderer: 'yesNoRenderer' }
      
        ]);
      }
    
	useEffect(() => {
        createColumnDefs()
        fetchDbnp()
	}, [pageData])

  const handleAdd=()=>{
    navigate(`${0}`)
  }
  const handleEdit=(data: any)=>{
    
    navigate(`${data?.Id}`)
  }
  const handleDelete=(data: any)=>{
    dispatch(dbnp.delete({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/dbn/dbnp/delete`,
      entity: 'dbnp',
      jsonData: {
          Records: [
              {
                  Id: data?.Id
              }
          ]
      }
  })).then(() => {
    dispatch(dbnp.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/dbn/dbnp/list`,entity:'dbnp',jsonData:{
  
    "PageNumber": pageData,
    "PageSize": 10,
    "SortField": "Id",
    "SortOrder": "desc",
    

    }}))
  });
  }
  const fetchDbnp=()=>{

    dispatch(dbnp.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/dbn/dbnp/list`,entity:'dbnp',jsonData:{
  
    "PageNumber": pageData,
    "PageSize": 10,
    "SortField": "Id",
    "SortOrder": "desc",
    

    }}))
   
  }
  const additionButtons: any = [
    {
      name: 'Add DBNP',
      callback: () => handleAdd(),
    }
  ];
	return (
        <>
           {dbnpItems?.isLoading ? 
      <PageLoader />
  : 
        <Table columnData={columnDefs} rowData={dbnpItems?.result?.items} setPageData={setPageData} 
        paginationData={dbnpItems?.result?.pagination} onEdit={handleEdit} onDelete={handleDelete} additionButtons={additionButtons} headingName="DBNP" />
           }
        </>
		
      
     
	);
};

export default ManagementDbnps;


